import {Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';


@Injectable({
  providedIn: 'root',
})
export class ShareaService {
  checkNull(value) {
    try {
      if (value == null) {
        return true;
      }
      value = value.trim();
      if (value === '' || value === 'undefined') {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  checkNullOrZero(value) {
    try {
      if (value == null || value === 0) {
        return true;
      }
      return false;
    } catch (e) {
      return true;
    }
  }

  debounce = (func, delay) => {
    let timerId;
    return function() {
      clearTimeout(timerId);
      timerId = setTimeout(() => func.apply(this, arguments), delay);
    };
  };

  throttle = (func, delay) => {
    let toThrottle = false;
    return function() {
      if (!toThrottle) {
        toThrottle = true;
        func.apply(this, arguments);
        setTimeout(() => {
          toThrottle = false;
        }, delay);
      }
    };
  };

  datatimeToDate(datetime: Date) {
    if (datetime == null) {
      return null;
    }
    let day = datetime.getDate();
    let month = datetime.getMonth();
    let year = datetime.getFullYear();

    return new Date(year, month, day);
  }

  datatimeToDateTimeZone(datetime: Date) {
    if (datetime == null) {
      return null;
    }
    let timezone = -datetime.getTimezoneOffset() / 60;
    let hours = datetime.getHours() + timezone;
    let minutes = datetime.getMinutes();
    let day = datetime.getDate();
    let month = datetime.getMonth();
    let year = datetime.getFullYear();

    return new Date(year, month, day, hours, minutes);
  }

  toNomalize(value) {
    if (value) {
      return value
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D');
    }
    return '';
  }

  toDDMMYY(date) {
    try {
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let year = date.getFullYear();
      return day + '/' + month + '/' + year;
    } catch (ex) {
      console.error(ex);
    }
  }

  covertDDMMYYtoYear(value) {
    try {
      let splitDate = value.trim().split('/');
      let date = new Date(splitDate[2], splitDate[1], splitDate[0]);
      return date;
    } catch (ex) {
      console.error(ex);
    }
  }

  checkEmpty(value) {
    if (value == null || value == '' || value == 'undefined') {
      return true;
    }
    return false;
  }

  toUnsign(val) {
    if (this.checkEmpty(val)) {
      return '';
    }
    return val
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  }

  printHtmlContent(
    htmlContent: string,
    title: string = null,
    additionCSS: string = null
  ) {
    let popupWin = window.open(
      '',
      '_blank',
      'top=0,left=0,height=100%,width=auto'
    );
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <meta content="width=device-width, initial-scale=1" name="viewport" />
    <head>
    <title>${title}</title>
    <style>
        strong{color:#000;}
        .table-bill-info td{
          padding: 2px 10px;
        }
        .table-detail td, .table-detail th{
          padding: 5px 10px;
        }


.row {
  display: -webkit-box;
  /* wkhtmltopdf uses this one */
  display: flex;
  /* -webkit-box-pack: center; */
  /* wkhtmltopdf uses this one */
  /* justify-content: center; */
}

div{
  line-height: 1.5em;
}

.row>div:last-child {
  margin-right: 0;
}

/* body {
  background-color: gray;
} */

.boder {
  border: 1px solid;
}

.boder-r {
  border-right: 1px solid;
}

.boder-bt {
  border-bottom: 1px solid;
}

.col-2 {
  width: 16.667%;
}

.col-3 {
  width: 25%;
}

.col-4 {
  width: 33.333%;
}

.col-5 {
  width: 41.66666%;
}

.col-6 {
  width: 50%;
}

.col-7 {
  width: 58.33333%;
}

.col-8 {
  width: 66.66667%;
}

.col-9 {
  width: 75%;
}

.col-12 {
  width: 100%;
}

.col-10 {
  width: 83.3333333333333333%;
}

.pd-4 {
  padding: 4px;
}

.pd-6 {
  padding: 6px;
}

.pd-10 {
  padding: 10px;
}

.info-text {
  font-size: 10px;
}

.box {
  display: flex;
  flex-wrap: wrap;
}

.box>* {
  flex: 1 1 1;
}

.data-tr {
  height: 16px;
}

.data-tr td,
.data-tr th {
  height: 16px;
}

* {
  -webkit-box-sizing: border-box;
}

.flex-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.flex-item>div {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  /* margin-right: 10%; */
}

.flex-item>div:last-child {
  margin-right: 0;
}
.title {
  font-size: 24px;
  font-weight: 600;
  margin-top: 40px;
  text-align: center;
  font-family: serif;
}
.text-medium {
  font-size: 18px;
}
.text-normal {
  font-size: 14px;
}
.info-row{
  margin-bottom: 4px;
}
.label {
  display: inline-block;
  min-width: 80px;
}

.img-row {
  display: table-row;
  vertical-align: inherit;
  /* border-color: inherit; */
  width: 100%;
}

table.border {
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
  font-size: 13px;
}

.border th,
.border td {
  padding: 2px 4px;
  border: 1px solid black;
  border-collapse: collapse;
}

.hightlight td{
  border-top: 2px solid black;
}

.align-right{
  text-align: right;
}

.align-center{
  text-align: center;
}

.category{
  font-weight: 600;
  text-transform: uppercase;
}

.bold{
  font-weight: 600;
}

.print-table-detail td,
.print-table-detail th {
  padding: 5px 10px;
}
.print-logo {
  min-width: 60%;
  max-width: 80%;
  max-height: 90px;
}

@page {
  size: auto;
  margin: 4mm;
}
@media print and (max-width: 791px) {
  body,
  table,
  .ant-tabs,
  .ant-table,
  table.border {
    font-size: 12px;
  }
  .text-medium {
    font-size: 14px;
  }
  .text-normal {
    font-size: 12px;
  }
  .title {
    font-size: 18px;
  }
  .print-table-detail td,
  .print-table-detail th {
    font-size: 12px;
    padding: 3px 6px;
  }
  .print-logo {
    max-height: 70px;
  }
  .label {
    min-width: 64px;
  }
}

@media print and (max-width: 559px) {
  body,
  table,
  .ant-tabs,
  .ant-table,
  table.border {
    font-size: 10px;
  }
  .text-medium {
    font-size: 12px;
  }
  .text-normal {
    font-size: 10px;
  }
  .title {
    font-size: 14px;
  }
  .print-table-detail td,
  .print-table-detail th {
    font-size: 10px;
    padding: 2px 4px;
  }
  .print-logo {
    max-height: 56px;
  }
  .label {
    min-width: 56px;
  }
}



${additionCSS}
    </style>
    </head>
    <body onload='window.print();window.close();'>${htmlContent}</body>
    </html>`);
    popupWin.document.close();
  }

  getStyleCommonPrint() {
    let style = `strong{color:#000;}
    table{
      width: 100%;
      page-break-inside:auto;
    }
    .label{
      display: inline-block;
      margin-right: 5px;
      font-weight: bold;
    }
    .bold{
      font-weight: bold;
    }
    .col-item{
      display: inline-block;
      margin-right: 15px;
      margin-bottom: 10px;
    }
    @page{
      margin: 3mm;
    }
    td{
      page-break-inside:avoid;
      page-break-after:auto;
    }
    .d-flex {
      display: flex;
    }
    label {
      margin-bottom: 0.5rem
    }
    .row{
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 4px;
    }
    .col-2{
      width: 16.66667%
    }
    .col-3{
      width: 25%
    }
    .col-4{
      width: 33.33333%
    }
    .col-5{
      width: 41.66667%
    }
    .col-6 {
      width: 50%;
    }
    .col-8{
      width: 66.66667%
    }
    .col-9 {
      width: 75%;
    }
    .col-12 {
      width: 100%;
    }
    .label {
      display: inline-block;
      margin-right: 5px;
      font-weight: bold;
      min-width: 65px;
    }
    .flex-item {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
    }

    .flex-item > div {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        /* margin-right: 10%; */
    }

    .flex-item > div:last-child {
        margin-right: 0;
    }`;
    return style;
  }

  public findInvalidFormControls(form: FormGroup) {
    const invalid = [];
    const controls = form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }
}
